/* eslint-disable no-underscore-dangle */

const cookies = require('cookies-js');

/** Product view switch button component */
function UIViewSwitch() {
  this.__element = document.querySelector('[data-component="view-switch"]');
  if (!this.__element) {
    return;
  }
  this.__newView = this.__element.getAttribute('data-view') || 'grid';
  this.__link = this.__element.querySelector('a');
  this.__cookieName = 'layout';

  this.attachClickHandler();
}

/**
 * Attaches click event to the switch button
 * @returns {void}
 */
UIViewSwitch.prototype.attachClickHandler = function attachClickHandler() {
  if (this.__link.addEventListener) {
    this.__link.addEventListener('click', this.onClick.bind(this), false);
  }
};

/**
 * Handles click events
 * @returns {void}
 */
UIViewSwitch.prototype.onClick = function onClick(event) {
  const optionsDelete = {
    domain: this.getCurrentDomain(),
    path: this.getSegmentUrl()
  };
  const optionsAdd = {
    domain: this.getCurrentDomain()
  };
  event.preventDefault();

  /**
   * We need Cookie.expire for users who have old cookies set with path.
   * It can be removed later.
   */
  cookies.expire(this.__cookieName, optionsDelete);
  cookies.set(this.__cookieName, this.__newView, optionsAdd);
  window.location.reload();
};

/**
 * Get current domain from address bar
 * @returns {string}
 */
UIViewSwitch.prototype.getCurrentDomain = function getCurrentDomain() {
  return window.location.host;
};

/**
 * Get current path from address bar
 * @returns {string}
 */
UIViewSwitch.prototype.getCurrentPath = function getCurrentPath() {
  return window.location.pathname;
};

/**
 * Extract part of URL before pagination segment or before "xx-criteria.html"
 * @returns {string}
 */
UIViewSwitch.prototype.getSegmentUrl = function getSegmentUrl() {
  const url = this.getCurrentPath();
  const regExpPagination = /^(.*)(\/[0-9]+_[0-9]+\/)/g;
  const regExpNoPagination = /^(.*)(\/[^/]+-criteria\.html)$/g;
  let urlMatches = regExpPagination.exec(url);
  if (urlMatches === null) {
    urlMatches = regExpNoPagination.exec(url);
  }
  return urlMatches !== null && urlMatches[1] !== undefined ? urlMatches[1] : '/';
};

module.exports = UIViewSwitch;
